import { Layout } from "../../layouts/v1";
import { MainView } from "../../views/smartstore/root";
import { CollectedOrderDatasContextProvider } from "../../views/smartstore/root/contexts/CollectedOrderDatasContext";
import { CommerceApiStoreInfoContextProvider } from "../../views/smartstore/root/contexts/CommerceApiStoreInfoContext";
import { SelectedCollectedOrderDataContextProvider } from "../../views/smartstore/root/contexts/SelectedCollectedOrderDataContext";
import { SelectedCommerceApiStoreInfosContextProvider } from "../../views/smartstore/root/contexts/SelectedCommerceApiStoreInfosContext";

export function SmartstorePage(props) {
    return (
        <>
            <CommerceApiStoreInfoContextProvider>
                <SelectedCommerceApiStoreInfosContextProvider>
                    <CollectedOrderDatasContextProvider>
                        <SelectedCollectedOrderDataContextProvider>
                            <Layout>
                                <MainView />
                            </Layout>
                        </SelectedCollectedOrderDataContextProvider>
                    </CollectedOrderDatasContextProvider>
                </SelectedCommerceApiStoreInfosContextProvider>
            </CommerceApiStoreInfoContextProvider>
        </>
    );
}